import React from 'react'
import { Tag } from 'antd'
import PropTypes from 'prop-types'
import styles from './styles'

const COLOUR = '#58bcc9'

const Categories = ({ categories }) => {
  return (
    <div className={styles.tag_wrapper}>
      {categories.map(({ name, uuid }) => {
        return uuid &&
          <Tag
            className={styles.tag}
            color={COLOUR}
            key={uuid}
          >
            {name.toUpperCase()}
          </Tag>
      })}
    </div>
  )
}

Categories.propTypes = {
  categories: PropTypes.array
}

export default Categories
